



import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { PostSiteEventMarkerContent, PostSiteEventMarkerContentResponse } from "../../api/dtos/dtos";
import usePost from "../api/usePost";

const getData = (response?: SWRResponse<PostSiteEventMarkerContentResponse, PostSiteEventMarkerContentResponse>) => response?.data;
const getError = (response?: SWRResponse<PostSiteEventMarkerContentResponse, PostSiteEventMarkerContentResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<PostSiteEventMarkerContentResponse, PostSiteEventMarkerContentResponse>) => ({});

const usePostSiteEventMarkerCollection = (query?: Partial<PostSiteEventMarkerContent>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query || !query.id) {
            return undefined;
        }

        return () => {
            return new PostSiteEventMarkerContent(query);
        }
    }, [query]);

    return usePost(request, { getData, getError, getAdditionalState }, configuration);
}

export default usePostSiteEventMarkerCollection;